export default __webpack_public_path__ + "static/media/Background-small.6d228209.svg";